import { NgModule } from "@angular/core";

import { MasterComponent } from "./components/master.component";
import { MenuComponent } from "./components/menu.component";
import { NavnotificationComponent } from "./components/navnotification.component";
import { BroadcastMessagesComponent } from "./components/broadcast-messages/broadcast-messages.component";
import { MySettingsDialogComponent } from "./components/my-settings-dialog/my-settings-dialog.component";
import { DataService_MySettings } from "./components/my-settings-dialog/shared/data.service";

import { NavNotificationService } from "./components/navnotification.service";
import { CommonModule } from "@angular/common";
import { MasterRoutingModule } from "./master-routing.module";
import { AuthguardService, MenuService, MenuResolve, MasterService } from "./services/";

import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { DialogModule } from "primeng/dialog";
import { FormsModule } from "@angular/forms";
import { DropdownModule } from "primeng/dropdown";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CustomTooltipModule } from "../../shared/custom-tool-tip/custom-tool-tip.component";
import { SupportChatWindowComponent } from "./components/support-chat-window/support-chat-window.component";
import { DataService_SupportChatWindow } from "./components/support-chat-window/shared/data.service";

@NgModule({
	declarations: [MenuComponent, NavnotificationComponent, BroadcastMessagesComponent, MySettingsDialogComponent, SupportChatWindowComponent, MasterComponent],
	imports: [
		CommonModule,
		MasterRoutingModule,
		ConfirmDialogModule,
		DialogModule,
		DynamicDialogModule,
		FormsModule,
		DropdownModule,
		BrowserAnimationsModule,
		CustomTooltipModule,
	],
	providers: [
		AuthguardService,
		MenuService,
		MenuResolve,
		MasterService,
		ConfirmationService,
		NavNotificationService,
		DataService_MySettings,
		DataService_SupportChatWindow,
	],
})
export class MasterModule {}
